import styled from '@emotion/styled'
import { Info } from '@entrata/portals-common/lib/icons'

export const StyledInfoBox = styled('div')`
  display: flex;
  align-items: flex-start;
  background: ${({ theme }) => theme.system_message.info.background};
  border-radius: 8px;
  padding: 16px;
  margin-top: 32px;
  color: ${({ theme }) => theme.system_message.info.text_color};
  font-size: 14px;
  font-weight: 400;
  border: 1px solid ${({ theme }) => theme.system_message.info.border};
`

export const StyledInfoIcon = styled(Info)`
  flex-shrink: 0;
  margin-right: 12px;
  color: ${({ theme }) => theme.system_message.info.icon_color};
  margin-top: 2px;
  width: 20px;
  height: 20px;
`

export const StyledInfoText = styled('div')`
  color: ${({ theme }) => theme.system_message.info.text_color};
`

export const StyledInfoTitle = styled('div')`
  margin-bottom: 6px;
  font-weight: bold;
`

// Styled components moved from RenewalOfferTable.jsx
export const StyledClickableSpan = styled('span')`
  color: ${({ theme }) => theme.blue.system_blue};
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
  font-size: 18px;
`

export const StyledChargesInfoIcon = styled('span')`
  color: ${({ theme }) => theme.gray.medium};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px 4px;
  vertical-align: middle;
  line-height: 1;
  position: relative;
  z-index: 1;

  &:hover::after {
    content: 'Includes fees billed through Entrata and fees\\A billed directly by service providers that will not\\A appear in your Entrata ledger.';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-style: normal;
    line-height: 1.4;
    color: #333;
    white-space: pre-line;
    text-align: right;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    width: 320px;
    margin-bottom: 8px;
  }
`

export const StyledChargesTooltip = styled('div')`
  padding: 10px;
  background-color: white;
  opacity: 1;
  border-radius: 8px;
  width: 280px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.gray.dark};
`

export const StyledTotalHeader = styled('span')`
  font-weight: bold;
  display: block;
  text-align: left;
  padding: 0;
  margin: 0;
  line-height: 1.2;
  font-size: 14px;
`

// Styled components moved from ChargeUpdatesModal.jsx
export const StyledHorizontalLine = styled('hr')`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.gray.light};
  margin: 8px 0;
`

export const StyledModalInfoText = styled('div')`
  font-size: 12px;
  color: ${({ theme }) => theme.gray.base};
  padding: 8px 0;
  text-align: left;
`

export const StyledSubtotalItem = styled('li')`
  color: ${({ theme }) => theme.gray.base};
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0;
  font-size: 12px;
  letter-spacing: 0.3px;

  :last-child {
    padding-top: 16px;
  }
`

export const StyledConditionalTotalItem = styled('li')`
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.gray.dark};

  :last-child {
    padding-top: 16px;
  }
`

// New styled components specifically for RenewalProjectedCharges
export const StyledRecurringSubtotalItem = styled('li')`
  color: ${({ theme }) => theme.gray.base};
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0;
  font-size: 13px;
  letter-spacing: 0.3px;

  :last-child {
    padding-top: 16px;
  }
`

export const StyledRecurringInfoText = styled('div')`
  font-size: 12px;
  color: ${({ theme }) => theme.gray.base};
  padding: 8px 0;
  text-align: left;
`

export const StyledRecurringSubtotalSpan = styled('span')`
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  font-size: 12px;

  &:after {
    width: 100%;
    border-bottom: 1px dashed ${({ theme }) => theme.gray.light};
    bottom: 4px;
    content: '';
    position: absolute;
  }
`

export const StyledRecurringSubtotalAmountSpan = styled('span')`
  font-size: 12px;
  margin-top: auto;
`

export const StyledConditionalRecurringTotalItem = styled('li')`
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.gray.dark};

  :last-child {
    padding-top: 16px;
  }
`

export const StyledCustomTotalItem = styled('li')`
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.gray.dark};

  :last-child {
    padding-top: 16px;
  }
`

export const StyledCustomTotalSpan = styled('span')`
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  font-size: 16px;
  font-weight: bold;

  &:after {
    width: 100%;
    border-bottom: 1px dashed ${({ theme }) => theme.gray.light};
    bottom: 4px;
    content: '';
    position: absolute;
  }
`

export const StyledCustomTotalAmountSpan = styled('span')`
  font-size: 16px;
  font-weight: bold;
  margin-top: auto;
`
